import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import Layout from "../../layouts";
import Header from "../../components/header";
import Callout from "../../components/callout";
import GalleryImage from "../../components/gallery-image";
var _default = /*#__PURE__*/ function (_React$Component) {
    _inheritsLoose(_default, _React$Component);
    function _default() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = _default.prototype;
    _proto.findImage = function findImage(imageName) {
        var _this$props$data$unsp, _this$props$data$unsp2;
        return (_this$props$data$unsp = this.props.data.unsplash.edges.find(function (e) {
            return e.node.name === imageName;
        })) === null || _this$props$data$unsp === void 0 ? void 0 : (_this$props$data$unsp2 = _this$props$data$unsp.node.childImageSharp) === null || _this$props$data$unsp2 === void 0 ? void 0 : _this$props$data$unsp2.fluid;
    };
    _proto.render = function render() {
        var _this$props$data$unsp3, _this$props$data$unsp4;
        return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(Header, {
            title: "Why Softgels?",
            image: (_this$props$data$unsp3 = this.props.data.unsplash.edges.find(function (e) {
                return e.node.name === "IMG_4055";
            })) === null || _this$props$data$unsp3 === void 0 ? void 0 : (_this$props$data$unsp4 = _this$props$data$unsp3.node.childImageSharp) === null || _this$props$data$unsp4 === void 0 ? void 0 : _this$props$data$unsp4.fluid
        }), /*#__PURE__*/ React.createElement("section", {
            className: "page page--whysoftgels"
        }, /*#__PURE__*/ React.createElement("h2", null, "Softgels have many desirable properties and several advantages over tablets, hard-shell capsules, and other delivery methods."), /*#__PURE__*/ React.createElement("div", {
            className: "grid grid--half grid--photo grid--center"
        }, /*#__PURE__*/ React.createElement(GalleryImage, {
            unsplashImageName: "no-smell-or-taste-limitations"
        }), /*#__PURE__*/ React.createElement(Callout, {
            title: "Consumer's Perspective",
            message: "Softgels are easier to take and trust than other delivery methods. Consumers can see that softgels are hermetically sealed, which not only protects the active ingredients in the fill material from oxidation, moisture, and microbial contamination, but also are tamper-proof and higher perceived value.",
            titlePosition: "center"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "grid grid--half grid--photo grid--center"
        }, /*#__PURE__*/ React.createElement(Callout, {
            title: "Enhanced Bioavailability and Dosing",
            message: "Softgel technology is proven to enhance bioavailability of poorly soluble molecules by protecting the entire dose until it\u2019s designed to be released for optimal absorption. This coupled with the formulation and manufacturing process allows for the most accurate and consistent dosing possible.",
            titlePosition: "center"
        }), /*#__PURE__*/ React.createElement(GalleryImage, {
            unsplashImageName: "2-color-blending"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "grid grid--half grid--photo grid--center"
        }, /*#__PURE__*/ React.createElement(GalleryImage, {
            unsplashImageName: "no-question-in-dosing"
        }), /*#__PURE__*/ React.createElement(Callout, {
            title: "Formulating Advantages",
            message: "Softgels mask the odor and taste of the ingredients used in the products. This is not the case with most delivery methods, meaning we are not limited to ingredient choices where others may be. In addition, softgels provide enhanced stability of the ingredients and help prevent degradation or oxidation.",
            titlePosition: "center"
        }))));
    };
    return _default;
}(React.Component);
export { _default as default };
var query = "3155504810";
